import { getAEMSummaryProps } from 'features/order-tracker/api/orderTrackerApi';
import { call, put, select } from 'redux-saga/effects';
import { setAEMPropsToStore } from '../../actions';

export function* getAEMHeadlessPropsRequest(): Generator {
  const { aemProps } = (yield select((state: unknown) => state)) as { aemProps: Record<string, unknown> };
  try {
    const response = (yield call(getAEMSummaryProps)) as Record<string, unknown>;
    yield put(setAEMPropsToStore({ ...aemProps, ...response }));
  } catch (error) {
    const { message } = error as { message: string };
    console.error('AEM Headless Request:', message);
  }
}
